import React, {LegacyRef, MutableRefObject, useCallback, useEffect, useState} from 'react'
import {Ellipse, Group, Layer, Line, Transformer} from 'react-konva'
import {TransformerLayerProps} from './TransformerLayer'

export function PolygonTransformerLayer(props: TransformerLayerProps) {
  const {points = []} = props.element.props
  const [pointsVisible, setPointsVisible] = useState(true)

  const updatePoints = useCallback(
    (points: number[]) => {
      props.onChange?.({
        type: props.element.type,
        elementId: props.element.elementId,
        name: props.element.name,
        shapeType: props.element.shapeType,
        props: {
          ...props.element.props,
          points,
        },
      })
    },
    [props.onChange]
  )

  useEffect(() => {
    const handleDragStart = () => {
      const shape = props.shapeRef.current

      const attributes = shape.getAttrs()
      const {x, y} = attributes

      console.log(x, y)
      setPointsVisible(false)
    }

    const handleDragEnd = (e) => {
      const shape = props.shapeRef.current

      const attributes = shape.getAttrs()
      const {x, y} = attributes

      // dirty hack: move changes x and y props, but we instead adjust coordinates, so x and y will need to be reset to 0
      shape.x(0)
      shape.y(0)

      updatePoints(
        points.map((coordinate, index) => {
          const isX = index % 2 === 0
          if (isX) {
            return coordinate + x
          } else {
            return coordinate + y
          }
        })
      )

      setPointsVisible(true)
    }

    props.shapeRef.current.on('dragstart', handleDragStart)
    props.shapeRef.current.on('dragend', handleDragEnd)

    return () => {
      if (props.shapeRef.current) {
        props.shapeRef.current.off('dragstart', handleDragStart)
        props.shapeRef.current.off('dragend', handleDragEnd)
      }
    }
  }, [props.shapeRef.current, points])

  const elements: React.ReactElement[] = []
  for (let i = 0; i < points.length; i += 2) {
    const x = points[i]
    const y = points[i + 1]
    const pointIndex = i

    if (props.mode === 'edit') {
      elements.push(
        <Ellipse
          key={i}
          stroke={'blue'}
          draggable={true}
          listening={true}
          x={x}
          y={y}
          radiusX={20}
          radiusY={20}
          onDragMove={(e) => {
            const newX = e.target.x()
            const newY = e.target.y()

            updatePoints(
              points.map((coordinate, index) => {
                if (index === pointIndex) {
                  return newX
                } else if (index === pointIndex + 1) {
                  return newY
                } else {
                  return coordinate
                }
              })
            )
          }}
        />
      )
    }

    const prevX = points[i >= 2 ? i - 2 : points.length - 2]
    const prevY = points[i >= 2 ? i - 1 : points.length - 1]

    elements.push(
      <Line stroke="blue" key={`line-${i}`} strokeWidth={3} points={[prevX, prevY, x, y]} />
    )
  }

  console.log('highlighted edge', props.transformerLayerProps?.highlightedEdge)

  if (props.transformerLayerProps?.highlightedEdge) {
    elements.push(
      <Line
        key="highlited-edge"
        points={props.transformerLayerProps?.highlightedEdge}
        stroke="red"
        strokeWidth={30}
      />
    )
  }

  if (!pointsVisible) {
    return null
  }

  return <Group>{elements}</Group>
}

// export function PolygonTransformerLayer(props: TransformerLayerProps) {
//   props.element.props.points

//   const handleChange = (e) => {
//     const shape = props.shapeRef.current

//     const attributes = shape.getAttrs()
//     const newProps: Record<string, any> = {}
//     for (const attributeName of attributesWhitelist) {
//       let value = attributes[attributeName]

//       if (Array.isArray(value) && typeof value[0] === 'number') {
//         value.map((point) => Math.round(point))
//       }
//       newProps[attributeName] = value
//     }

//     props.onChange?.({
//       type: props.element.type,
//       elementId: props.element.elementId,
//       name: props.element.name,
//       shapeType: props.element.shapeType,
//       props: newProps,
//     })
//   }

//   return (
//     <Transformer
//       flipEnabled={false}
//       rotateEnabled={props.mode === 'edit'}
//       ref={props.transformerRef}
//       draggable={props.mode === 'edit'}
//       borderEnabled={true}
//       resizeEnabled={props.mode === 'edit'}
//       onDragMove={handleChange}
//       onTransform={handleChange}
//     />
//   )
// }
